const navbarLinks = [
    {
        index : 0,
        link: 'Use cases'
    },
    {
        index: 1,
        link: 'Why View'
    },
    {
        index: 2,
        link: 'Pricing'
    },
    {
        index: 3,
        link: 'Resources'
    }
]
export default navbarLinks